export class SmartTagFormControlModel {
	public field?: string;
	public title?: string;
	public control?: string;
	public condition?: SmartTagFormControlConditionModel;
	public options?: SmartTagFormControlOption[];
	public outputType?: SmartTagFormControlOutputType;
	public uiControl?: string;
}

export class SmartTagFormControlConditionModel {
	public and?: SmartTagFormControlConditionOperationModel[];
	public or?: SmartTagFormControlConditionOperationModel[];
	public not?: SmartTagFormControlConditionOperationModel[];
}

export class SmartTagFormControlConditionOperationModel {
	public field?: string;
	public value?: string;
}

export class SmartTagFormControlOption {
	public label?: string;
	public value?: string;
}

export enum SmartTagFormControlType  {
	SINGLE = 'Single',
	MULTIPLE = 'Multiple',
	TEXT = 'Text',
	NUMBER = 'Number',
	BOOL = 'Boolean'
}

export enum SmartTagFormControlOutputType {
	ARRAY = 'Array'
}
